import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import {
  ImageAttributionText,
  StyledImageWithAttribution,
} from './styles';

export const ImageWithAttribution = ({
  className = '',
  attributionText,
  maxWidth = null,
  children,
}) => {
  const wrapperRef = useRef(null);
  const [imgOffset, setImgOffset] = useState({ left: 0, bottom: 0 });

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const img = wrapper.querySelector('img[data-main-image]');
    if (!img) return;

    const updateOffsets = () => {
      const containerRect = wrapper.getBoundingClientRect();
      const containerWidth = containerRect.width;
      const containerHeight = containerRect.height;

      const { naturalWidth } = img;
      const { naturalHeight } = img;

      // Calculate rendered image size using object-fit: contain rules
      const containerRatio = containerWidth / containerHeight;
      const imageRatio = naturalWidth / naturalHeight;

      let renderedWidth; let
        renderedHeight;

      if (imageRatio > containerRatio) {
      // Image is wider than container
        renderedWidth = containerWidth;
        renderedHeight = containerWidth / imageRatio;
      } else {
      // Image is taller than container
        renderedHeight = containerHeight;
        renderedWidth = containerHeight * imageRatio;
      }

      const left = Math.round((containerWidth - renderedWidth) / 2);
      const bottom = Math.round((containerHeight - renderedHeight) / 2);

      setImgOffset({ left, bottom });
    };

    if (!img.complete) {
      img.addEventListener('load', updateOffsets);
    } else {
      updateOffsets();
    }

    window.addEventListener('resize', updateOffsets);

    // eslint-disable-next-line consistent-return
    return () => {
      img.removeEventListener('load', updateOffsets);
      window.removeEventListener('resize', updateOffsets);
    };
  }, []);

  return (
    <StyledImageWithAttribution className={className} ref={wrapperRef}>
      {children}
      <ImageAttributionText
        $maxWidth={maxWidth}
        $bottom={imgOffset.bottom}
        $left={imgOffset.left}
      >
        {attributionText}
      </ImageAttributionText>
    </StyledImageWithAttribution>
  );
};

ImageWithAttribution.propTypes = {
  className: PropTypes.string,
  maxWidth: PropTypes.number,
  children: PropTypes.node.isRequired,
  attributionText: PropTypes.string.isRequired,
};
